<template>
    <div class="enps-overall">
        <!-- Полоска и число средней — по шкале значения (>=4 / >=3 / <3 из enpsColors.js):
             карточка отвечает на «хорошо ли у нас?» ещё до чтения цифры. У остальных карточек
             полоска в цвет их метрики (доля оценённых — золото её же графика, доля 4–5 —
             зелёный «хороших» оценок), объём — нейтральный. -->
        <div class="enps-overall__tile" :style="{ borderLeftColor: averageColor }">
            <span class="enps-overall__value" :style="{ color: averageColor }">
                {{ overall.averageRating ?? '—' }}
            </span>
            <span class="enps-overall__label">Средняя оценка по команде</span>
        </div>

        <div class="enps-overall__tile enps-overall__tile_rated-share">
            <span class="enps-overall__value">
                {{ ratedShare.percentage !== null ? `${ratedShare.percentage}%` : '—' }}
            </span>
            <span class="enps-overall__label">
                Доля оценённых ({{ ratedShare.ratedCount }} из {{ ratedShare.closedCount }})
            </span>
        </div>

        <div class="enps-overall__tile enps-overall__tile_top-share">
            <span class="enps-overall__value">
                {{ topRatingsShare.percentage !== null ? `${topRatingsShare.percentage}%` : '—' }}
            </span>
            <span class="enps-overall__label">Доля оценок 4–5</span>
        </div>

        <div class="enps-overall__tile enps-overall__tile_volume">
            <span class="enps-overall__value">{{ overall.ratingsCount }}</span>
            <span class="enps-overall__label">Оценённых обращений</span>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ratingTextColor } from '@/js/enpsColors';

@Component
class EnpsOverallStats extends Vue {
    @Prop({ type: Object, default: () => ({ averageRating: null, ratingsCount: 0 }) })
    overall;
    // pt.1: числитель — оценённые обращения периода, знаменатель — ВСЕ закрытые за период
    // (не только оценённые) — вторая карточка в ряду, сразу после средней оценки.
    @Prop({ type: Object, default: () => ({ ratedCount: 0, closedCount: 0, percentage: null }) })
    ratedShare;
    // pt.2: доля оценок 4 и 5 среди всех выставленных — отдельно от средней, т.к. среднее
    // сглаживает плохой опыт, а эта метрика — нет.
    @Prop({ type: Object, default: () => ({ topCount: 0, totalCount: 0, percentage: null }) })
    topRatingsShare;

    get averageColor() {
        // text-вариант шкалы: полутоновым цветом бара крупную цифру не напишешь.
        return ratingTextColor(this.overall.averageRating);
    }
}

export default EnpsOverallStats;
</script>
<style lang="scss">
.enps-overall {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;

    &__tile {
        display: flex;
        flex: 1;
        padding: 14px 20px;
        flex-direction: column;
        justify-content: center;
        gap: 2px;
        border-left: 4px solid transparent;
        border-radius: 8px;
        background-color: var(--color-white);
        box-shadow: 0px 1px 10px rgba(88, 88, 88, 0.15);

        // Цвета полосок — из enpsColors.js: SERIES.ratedShare / RATING_SCALE.good / SERIES.rest.
        &_rated-share {
            border-left-color: #cfa14f;
        }

        &_top-share {
            border-left-color: #00a55a;
        }

        &_volume {
            border-left-color: #b9b1a9;
        }
    }

    &__value {
        font-size: 1.75rem;
        font-weight: 600;
        line-height: 1.2;
    }

    &__label {
        font-size: 0.8125rem;
        color: #767676;
    }
}
</style>
